// Angular Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';

// Internal Component
import { DatepickerComponent } from './datepicker.component';

const angularModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatInputModule,
  MatDatepickerModule,
];

@NgModule({
  exports: [DatepickerComponent],
  imports: [...angularModules, DatepickerComponent],
})
export class DatepickerModule { }
